import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Order/OrderDetail/orderDetail.container"
    ).then((module) => ({
        default: module.OrderDetail
    }))
);
